// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"deedd4f9","622":"4f5dfd5b","778":"ade8616c","828":"36055f46","973":"1c105e07"}[chunkId] + ".chunk.js";
};